// extracted by mini-css-extract-plugin
export default {"playIcon":"MediaPreview_playIcon__vx799","md":"MediaPreview_md__PJfCV","sm":"MediaPreview_sm__TiH1i"};